<template>
  <div class="restView">
  <L1>
    <template slot="slot_title">
      <Select :defaultValue="area" @input="$router.replace({ name: restaurantView[$event], query: { page: $event } });addnew=false;itemSelected=null" :width="'650px'">
        <option v-for="(rest, r) in restaurants" :key="`rest-${r}`" :value="rest" >{{rest}}</option>
      </Select>
      <Round :icon="'add'" :text="'新增預約'" :bg="'var(--color-pri)'"
      :style="{marginLeft: 'auto'}" @click="addnew=!addnew;itemSelected=null"></Round>
    </template>
    <LaTable v-if="area&&storeType&&types&&statuslistselectable">
      <template slot="filter">
        <Select :width="'155px'" :defaultValue="status" @input="status=$event">
          <option :value="null">所有訂單</option>
          <option v-for="(stat, i) in statuslistselectable" :key="`stat-${i}`" :value="stat">{{stat}}</option>
        </Select>
        <Select :width="'155px'" :defaultValue="type" @input="type=$event">
          <option :value="null">所有類型</option>
          <!-- <option v-for="(stat, i) in ['自取', '宅配']" :key="`stat-${i}`" :value="stat">{{stat}}</option> -->
          <option v-for="(stat, i) in types" :key="`stat-${i}`" :value="stat">{{stat}}</option>
        </Select>
        <Select v-if="storeType==='shop'" :width="'205px'" :defaultValue="sort" @input="sort=$event">
          <option :value="null">依取貨日期排序</option>
          <option :value="'productionDate'">依排單製作排序</option>
        </Select>
        <dates-select :defaultValue="range" @input="range=$event"/>
        <search :defaultValue="searchText" @input="searchText=$event"/>
        <div :style="{marginLeft: 'auto'}"></div>
        <template v-if="range.duration===0&&rows&&instore.length>0&&storeType==='restaurant'">
        <Round :text="'排桌'" :bg="'#7A94B5'" :style="{height: '50px'}"  @click="prearange2=true"/>
        <Round :text="'預排'" :bg="'#7A94B5'" :style="{height: '50px'}"  @click="prearange=true"/>
        </template>
        <div :style="{position: 'relative', width: 'fit-content'}">
            <template v-if="storeType==='restaurant'">
              <Round :icon="'print'" @click="printshow = !printshow" :text="'列印'" :bg="'var(--color-pri)'"></Round>
              <div v-if="printshow" :style="{position: 'absolute', display: 'flex', flexDirection: 'column', width: 'fit-content', top: 'calc(100% + 2px)', right: 0, gap: '1px', backgroundColor:'#FFFFFF', zIndex: '100'}">
                <Round :icon="'print'" @click="print('instore')" :text="'內用列表'" :bg="'var(--color-pri)'"
                v-if="(rows.filter(e => e.type === '內用')).length"
                :style="{boxShadow: 'var(--btn-shadow)', borderRadius: '0'}"
                />
                <Round :icon="'print'" @click="print('takeout')" :text="'外帶列表'" :bg="'var(--color-pri)'" :style="{borderRadius: '0'}"
                v-if="(rows.filter(e => e.type === '外帶')).length > 0 "></Round>
                <Round :icon="'print'" @click="preview" :text="'品項統計'" :bg="'var(--color-pri)'" :style="{borderRadius: '0'}"></Round>
              </div>
            </template>
            <template v-else-if="storeType==='tickets'">
            <Round :icon="'print'" @click="print('tickets')" :text="'預約列表'" :bg="'var(--color-pri)'"></Round>
            </template>
        </div>
        <Round :icon="'print'" @click="preview" :text="'品項統計'" v-if="storeType==='shop'" :bg="'var(--color-pri)'" :style="{}"></Round>
        <Round :icon="'excel1'" :text="'匯出'" :bg="'var(--color-pri)'" @click="exportFile"></Round>
        <Round :icon="'excel1'" :text="'匯出託運'" :bg="'var(--color-pri)'" v-if="storeType==='shop'" @click="exportCat=true"></Round>
      </template>
      <T2 :rows="rows">
        <template slot="slot_head">
          <th :style="{textAlign:'center', width: '142px'}">狀態</th>
          <th :style="{textAlign:'center', width: '84px'}">類型</th>
          <th :style="{textAlign:'center', width: '94px'}">訂單編號</th>
          <th :style="{textAlign:'start',  width: '144px'}">預約日期</th>
          <th :style="{textAlign:'start',  width: '84px'}">時段</th>
          <th :style="{textAlign:'center', width: '36px'}"></th>
          <th :style="{textAlign:'start',  width: '154px'}">預約人</th>
          <th :style="{textAlign:'start',  width: '214px'}" v-if="storeType!=='event'">公司行號</th>
          <th :style="{textAlign:'start',  width: '114px'}" v-else>專案</th>
          <th :style="{textAlign:'start',  width: '144px'}" v-if="storeType==='tickets'">領隊</th>
          <th :style="{textAlign:'center',  width: '144px'}" v-if="storeType==='event'&&field2">{{field2}}</th>
          <th :style="{textAlign:'center',  width: '144px'}" v-if="storeType==='event'&&field3">{{field3}}</th>

          <th :style="{textAlign:'center', width: '110px', whiteSpace: 'nowrap'}" v-if="storeType!=='shop'">預約人數</th>
          <th :style="{textAlign:'center', width: '60px', whiteSpace: 'nowrap'}" v-if="storeType==='restaurant'">桌</th>
          <th :style="{textAlign:'center', width: '60px', whiteSpace: 'nowrap'}" v-if="storeType==='restaurant'">套</th>
          <th :style="{textAlign:'start', width: '145px'}"  v-else>排單製作</th>

          <th :style="{textAlign:'center',  width: '80px', whiteSpace: 'nowrap'}" v-if="storeType==='tickets'">導覽員</th>
          <th :style="{textAlign:'start', width: 'inherit'}">備註</th>
          <th :style="{textAlign: 'center', width: '60px'}"></th>
          <th :style="{textAlign:'center', width: '164px', paddingRight: '13px'}" v-if="storeType!=='tickets'">金額</th>
          <th :style="{textAlign:'center', width: '90px', paddingRight: '33px'}" v-if="storeType==='restaurant'"></th>
        </template>
        <tr slot-scope="{item,index}" :style="{position:'relative'}"
        @click="itemSelected=(itemSelected&&itemSelected._id===item._id) ? null : item; addnew=false"
        :class="itemSelected&&itemSelected._id===item._id?'selected':''">
          <td><HoverSelect @input="changeStatus($event, item._id, index, item)" :defaultValue="item.status || '待確認'"
            :options="(item.InvoiceNo && item.InvoiceNo.length > 0)  ? ['已報到', '已完成', '快速預約園區'] : [...getStatuslistselectable(item), '快速預約園區']"></HoverSelect></td>
          <td :style="{textAlign: 'center', zIndex: 10}">
            <div class="ordertype" :style="{whiteSpace:'nowrap'}" :class="[item.type, (!item.tables || item.tables.length===0) ? 'notable' : '']"
            :aa="(item.tables || []).join(' ')">{{item.type||'-'}}</div>
          </td>
          <td>
            <div v-if="item.serialNo">A{{item.serialNo.toString().padStart(5, 0)}}</div>
            <div v-else>------</div>
            <div :style="{width: '100%', height: '10px', backgroundColor: item.color || 'var(--color-checked)'}"></div>
          </td>
          <td :style="{textAlign: 'start', zIndex: 9, whiteSpace: 'nowrap'}">
           <div v-if="!item.paidAtERP&&item.paidTime" :style="[{ position: 'absolute', top: '10px', fontSize: '14px' }, item.cancelTime ? { color: '#CACACA' } : item.paidTime ? { color: 'var(--color-tab)' } : {}]">
            {{ (item.cancelTime ? '退' : '售') + ((item.InvoiceNo || []).join(',') || item.inv.map(e => e.InvoiceNo).join(',') || moment(item.cancelTime || item.paidTime).format('YYYY-MM-DD HH:mm').slice(2)) }}<br>
           </div>
           {{moment(item.visitDate).format('YYYY-MM-DD')||'-'}}
          </td>
          <td :style="{textAlign: 'start', zIndex: 8}">{{item.visitTime||'-'}}</td>
          <td :style="{textAlign: 'center', zIndex: 7, padding: 0}">
            <div :class="item.level===1?'vip':item.level===2?'vvip':item.level===3?'supervip':''"></div>
          </td>
          <td :style="{textAlign: 'start', zIndex: 6, lineHeight: '35px'}">
            <div class="flex" :style="{fontWeight: 700}">
              <span v-if="item.orderer==='現場來客'&&(item.member||item.ordererID)">現場會員<br><span :style="{fontWeight: 700}">{{(item.member||item.ordererID)?.name}}</span></span>
              <span v-else-if="item.orderer==='現場來客'">現場來客</span>
              <span :style="{fontWeight: 700}" v-else>{{item.orderer}}</span>
              <HoverInfo
              :z="11 + Math.abs(rows.length - index - 3) * 10" :style="{marginLeft: '5px', zIndex: 0}" :info="(item.member||item.ordererID).internalRemark"
              v-if="item.member||item.ordererID" :bg="'#FFE8E8'" color="#FF7373">
                <div :class="(item.member||item.ordererID)?.internalRemark?'remarked':''"></div>
              </HoverInfo>
            </div>
            <span :style="{color: '#787878'}">{{item.ordererTel||((item.member||item.ordererID)?.mobile)||'-'}}</span>
          </td>
          <td v-if="storeType!=='event'" :style="{textAlign: 'start', lineHeight: '35px'}">{{item.agencyName||'-'}}<br><span :style="{color: '#B9B9B9'}" v-if="storeType!=='tickets'">{{item.project||'-'}}</span><span :style="{color: '#B9B9B9'}" v-else>{{item.groupName||'-'}}</span></td>
          <td v-else :style="{textAlign: 'start', lineHeight: '35px'}"><span :style="{color: '#B9B9B9'}" v-if="storeType!=='tickets'">{{item.project||'-'}}</span></td>

          <td :style="{textAlign:'center',  width: '144px'}" v-if="storeType==='event'&&field2">{{item.recipient}}</td>
          <td :style="{textAlign:'center',  width: '144px'}" v-if="storeType==='event'&&field3">{{item.recipientTel}}</td>
          <td :style="{textAlign: 'start', lineHeight: '35px'}" v-if="storeType==='tickets'"><span :style="{fontWeight: '700', lineHeight: '35px'}">{{item.recipient||'-'}}</span><br><span :style="{color: '#787878', lineHeight: '35px'}">{{item.recipientTel||'-'}}</span></td>
          <td :style="{textAlign:'center'}" v-if="storeType==='restaurant'||storeType==='event'">
            <span>{{(item.reserveNum||0)+(item.reserveNumChild||0)}}</span><br>
            <span v-if="item.reserveNumChild" :style="{whiteSpace:'nowrap'}">(<span>{{(item.reserveNum||0)}}</span>大<span>{{(item.reserveNumChild||0)}}</span>小)</span>
            <span v-else>(<span>{{(item.reserveNum||0)}}</span>大)</span>
          </td>
          <td :style="{textAlign:'center'}" v-if="storeType==='restaurant'">
            {{parseFloat(reduce(item.Orders.filter(e => e.t === 'set' && e.unit === '桌').map(e => e.count)).toFixed(1)) || '-'}}
          </td>
          <td :style="{textAlign:'center'}" v-if="storeType==='restaurant'">
            {{reduce(item.Orders.filter(e => e.t === 'set' && e.unit !== '桌').map(e => e.count)) || '-'}}
          </td>
          <td v-else-if="storeType==='shop'" :style="{textAlign: 'start', zIndex: 3, whiteSpace: 'nowrap'}" class="highlight">{{item.productionDate?toDate(item.productionDate):''}}</td>
          <td :style="{textAlign:'center'}" v-else>
            <span>{{(item.reserveNum||0)+(item.reserveNumChild||0)}}</span>
          </td>
          <!-- 園區: 導覽員 -->
          <td  v-if="storeType==='tickets'">{{reduce(item.Orders.filter(e => new RegExp('導覽', 'ig').test(e.name)).map(e => e.count))||'-'}}</td>
          <!-- {{(item.remark?item.remark.length> 28?item.remark.slice(0, 28)+'...':item.remark:'-')||'-'}} -->
          <td :style="{textAlign: 'start', zIndex: 2, lineHeight: '35px'}">
            <div v-if="storeType==='tickets'&&item.remitAmount" :style="{display: 'flex', gap: '8px', flexWrap: 'wrap', lineHeight: '26px'}">
              <span :style="{whiteSpacing:'nowrap', fontSize: '20px', fontWeight: '400', letterSpacing:'1px'}">{{moment(item.remitTime).format('YYYY/MM/DD HH:mm')}}</span>
              <span v-if="item.remit5code">[{{item.remit5code}}]</span>
              <span v-if="item.remitName">[{{item.remitName}}]</span>
              <span class="highlight" :style="{whiteSpacing:'nowrap', fontSize: '20px', fontWeight: '700', letterSpacing:'1px'}">${{item.remitAmount}}</span>
            </div>
            <div v-if="storeType==='tickets'&&item.remitAmount" class="toolong" :style="{maxWidth: storeType==='tickets'?'493px':'455px'}">{{item.remark}}</div>
            <div v-else class="toolong2" :style="{maxWidth: storeType==='tickets'?'493px':'455px'}">{{item.remark}}</div>
          </td>
          <td>
            <HoverInfo v-if="(item.remark||item.remarkKitchen)" :bg="'var(--color-checked)'" :color="'#FFFFFF'" :style="{zIndex: 0}"
            :info="[item.remark ? '一般備註: '+item.remark : null, item.remarkKitchen ? '內部備註: '+item.remarkKitchen : null].filter(e => e).join('<br>')" :z="999" :position="'Left'">
              <div class="remark"></div>
            </HoverInfo>
          </td>
          <td :style="{textAlign: 'start', zIndex: 1, paddingRight: '13px'}" v-if="storeType!=='tickets'">
            <span  :style="{fontSize: '24px', fontWeight: '500', letterSpacing: '2px'}">
              {{item.price||reduce(item.Orders.map(e => priceEach(e) * e.count))}}<br>
              <span v-if="item.remit" class="highlight" :style="{whiteSpacing:'nowrap', fontSize: '20px', fontWeight: '700', color: item.remit.status !== '已取消' ? '#9DC56E' : '#CACACA', letterSpacing:'1px'}">訂金:{{item.remit.price}}</span>
              <span v-else-if="item.remitInfo&&item.remitInfo.Trans_Amount" class="highlight"
              :style="[
                {whiteSpacing:'nowrap', fontSize: '20px', fontWeight: '700', letterSpacing:'1px', color: '#9DC56E'},
                (item.remitInfo.refundList || []).length > 0 ? {color:'#CACACA'} : {},
                (item.remitInfo.ecRefund?.Status === 'Cancelled') ? {color:'#CACACA'} : {},
                ((item.remitInfo.CloseData || []).length > 0 && item.remitInfo.CloseData.slice(-1)[0].Amount < 0) ? {color:'#CACACA'} : {}
              ]"
              :title="`[${item.remitInfo.remitType === 'LINE PAY' ? '線上LINEPAY' : item.remitInfo.remitType === '信用卡' ? '綠界信用卡' : item.remitInfo.remitType }]${item.remitInfo.Trans_Amount}`"
              >[{{item.remitInfo.remitType === 'LINE PAY' ? '線上LINE' : item.remitInfo.remitType === '信用卡' ? '綠界信用卡' : item.remitInfo.remitType }}]</span>
              <span v-else-if="item.remitAmount" class="highlight" :style="{whiteSpacing:'nowrap', fontSize: '20px', fontWeight: '700', letterSpacing:'1px'}">訂金:{{item.remitAmount}}</span>
            </span>
          </td>
          <td v-if="storeType==='restaurant'" :style="{paddingRight: '33px'}">
            <button v-if="item.Orders.find(e => e.unit === '桌')" @click.stop="printSheet(item)"  class="printBtn" >印</button>
            <span v-else>----</span>
          </td>
        </tr>
      </T2>
  </LaTable>
  </L1>
  <template  v-if="area&&storeType&&types&&statuslistselectable">
  <infoSlider v-if="addTeam" :show="addTeam" @close="addTeam=false" label="新增團體" :width="481" :icon="'team'">
    <new-team :sources="sourcesTeam" :teamAttributes="teamAttributes" @new="getnewteam" v-if="addTeam" :visitDate="addTeam.visitDate" :addTeam="addTeam" @close="addTeam=null" :show="addTeam"/>
  </infoSlider>
  <AddCube :source="source" :field2="field2" :field3="field3" :types="types" :storeType="storeType" :store="area" @updateItem="addItem" @close="addnew=null" :add="addnew" :salesmans="salesmans" :projects="projects"
  :statuslist="getStatuslistselectable()" :products="products"/>
  <EditCube :messageTemplate="remitConfirmMessage" :messageTemplate2="remitNotifyMessage"  @sendMessage="isMsgSend=$event" :source="source" :field2="field2" :field3="field3" :types="types" :storeType="storeType" :store="area" @updateItem="updateItem" @remitUpdate="remitUpdate"
  @close="itemSelected=null" :item="itemSelected" :salesmans="salesmans" :projects="projects" @print="print('sheet')"
  :statuslist="getStatuslistselectable(itemSelected)" :products="products"/>
  <preTable @update="getdata" @close="prearange=false" v-if="prearange" :date="range.start" :store="area" :sheets="instore"/>
  <preTable2 @update="getdata" @close="prearange2=false" v-if="prearange2" :date="range.start" :store="area" :sheets="instore"/>
  <restInstoreVue :style="{display:'none'}" v-if="storeType==='restaurant'" :rows="rows.filter(e => e.type === '內用')" :range="range"/>
  <restTakeoutVue :style="{display:'none'}" v-if="storeType==='restaurant'" :rows="rows.filter(e => e.type === '外帶')" :range="range"/>
  <restTicketsVue :style="{display:'none'}" v-if="storeType==='tickets'" :rows="rows" :range="range"/>
  <restSummaryVue :summary="summary" :range="range" :sort="sort"/>
  <restSheetVue :item="itemPrint"/>
  <ExportCatVue :rows="rows" :range="range" v-if="exportCat" @close="exportCat=false"/>
  <PrintSheet :sheet="itemSelected" v-if="itemSelected"/>
  </template>
  <dialognoPadding2 :show="isMsgSend" :label="'傳送確認簡訊'" v-if="isMsgSend" @close="isMsgSend=null">
    <div class="messagecontainer">
      <textarea v-model="isMsgSend.text" cols="30" rows="10"></textarea>
      <div class="phone"><div>電話號碼: </div><input type="tel" v-model="isMsgSend.phone"></div>
      <BtnsS @cancel="isMsgSend=null" @save="textMsgSend" :save="'傳送'"/>
    </div>
  </dialognoPadding2>
</div>
</template>

<script>
import dialognoPadding2 from '../../components/dialognoPadding2.vue'
import ExportCatVue from './exportDialog.vue'
import XLSX from 'xlsx'
import NewTeam from '../visitbooking/NewTeam.vue'
import restSheetVue from './print/rest_sheet.vue'
import restSummaryVue from './print/rest_summary.vue'
import restTakeoutVue from './print/rest_takeout.vue'
import restTicketsVue from './print/rest_tickets.vue'
import restInstoreVue from './print/rest_instore.vue'
import AddCube from './addnew.vue'
import EditCube from './edit.vue'
import infoSlider from '../../components/infoSlider_v2.vue'
// import SqrBtn from '../../components/btn/sqr40016.vue'
import HoverInfo from '../../components/hoverInfo.vue'
import DatesSelect from '../../components/dateRadio/DatesSelect.vue'
import HoverSelect from '../../components/hoverSelect.vue'
import Search from '../../components/input/search.vue'
import L1 from '../../components/layout/L1.vue'
import Select from '../../components/select.vue'
import T2 from '../../components/tables/t2.vue'
import { getapi, putapi } from '../../store/fetch'
import Round from '../../components/btn/round.vue'
import { mapState } from 'vuex'
import preTable from './preTable.vue'
import preTable2 from './preTable2.vue'
import LaTable from '../../components/layout/LaTable.vue'
import stringifyCss from './print/css'
import PrintSheet from './print/single.vue'
export default {
  components: { dialognoPadding2, PrintSheet, ExportCatVue, restSheetVue, restTicketsVue, restSummaryVue, restTakeoutVue, restInstoreVue, preTable, preTable2, LaTable, L1, Select, DatesSelect, Search, T2, HoverSelect, HoverInfo, AddCube, EditCube, Round, NewTeam, infoSlider },
  data () {
    return {
      // x: [],
      isMsgSend: false,
      exportCat: false,
      teamAttributes: [],
      addTeam: null,
      printshow: false,
      addnew: false,
      status: null,
      type: null,
      sort: null,
      searchText: null,
      prearange: false,
      prearange2: false,
      range: {
        start: this.moment().format('yyyy-MM-DD'),
        duration: 0,
        end: this.moment().format('yyyy-MM-DD')
      },
      rows: [],
      count: 0,
      itemSelected: null,
      itemPrint: null,
      salesmans: [],
      products: [],
      summary: null,
      source: [],
      projects: []
    }
  },
  computed: {
    ...mapState({
      restaurants: 'restaurants',
      defaultStore: 'defaultStore',
      restaurantView: 'restaurantView'
    }),
    remitConfirmMessage () {
      return this.$store.getters.getStoreByKey(this.area, 'remitConfirmMessage')
    },
    remitNotifyMessage () {
      return this.$store.getters.getStoreByKey(this.area, 'remitNotifyMessage')
    },
    date () {
      return this.$route.query.date
    },
    area () {
      return this.$route.query.page
    },
    instore () {
      return (this.rows || []).filter(e => e.type === '內用' && e.status !== '已取消' && e.status !== '已完成')
    },
    field2 () {
      if (this.area) {
        return this.$store.getters.getField2(this.area)
      } else {
        return null
      }
    },
    field3 () {
      if (this.area) {
        return this.$store.getters.getField3(this.area)
      } else {
        return null
      }
    },
    storeType () {
      if (this.area) {
        return this.$store.getters.getStoreType(this.area)
      } else {
        return null
      }
    },
    types () {
      if (this.area) {
        return this.$store.getters.getTypeList(this.area)
      } else {
        return []
      }
    },
    statuslistselectable () {
      if (this.area) {
        return this.$store.getters.getStatusList(this.area)
      } else {
        return []
      }
    }
  },
  beforeDestroy () {
    this.onListen(false)
  },
  async mounted () {
    if (global.socket && global.socket.connected) {
      this.onListen(true)
    }
    this.source = await getapi('selections/source')
    this.sourcesTeam = await getapi('selections/sourceTeam')
    this.teamAttributes = await getapi('selections/teamAttributes')
    const salesmans = await getapi('users/local/short')
    this.salesmans = salesmans
    const projects = await getapi(`restaurantSetting/${this.area}/restProject`)
    this.projects = projects
    if (this.$route.query.start) {
      this.range = {
        start: this.$route.query.start,
        end: this.$route.query.start
      }
    }
    // this.getcolor()
  },
  watch: {
    date () {
      if (this.date) {
        this.range = {
          start: this.date,
          end: this.date
        }
        const query = JSON.parse(JSON.stringify(this.$route.query))
        delete query.date
        this.$router.replace({ name: this.$route.name, query })
      }
    },
    area: {
      async handler () {
        await this.getproducts()
        await this.getdata()
      },
      immediate: true
    },
    async searchText () { await this.getdata() },
    async status () { await this.getdata() },
    async type () { await this.getdata() },
    async sort () { await this.getdata() },
    range: {
      async handler () { await this.getdata() },
      deep: true
    }
  },
  methods: {
    async textMsgSend () {
      const r = await putapi('textMessage', this.isMsgSend)
      if (r) {
        console.log('[textMsgSend]', r)
        if (['0', '1', '2', '4'].includes(r.code)) {
          alert('傳送成功')
          this.isMsgSend = null
        } else {
          alert(r.message)
        }
      }
    },
    getStatuslistselectable (item) {
      let list = JSON.parse(JSON.stringify(this.statuslistselectable))
      if (item) {
        if (item.remit || item.remitInfo) { list = list.filter(e => e !== '已付訂').filter(e => e !== '通知付訂') }
        if (!item.remitAmount || !item.remitTime) { list = list.filter(e => e !== '已付訂').filter(e => e !== '通知付訂') }
        return list
      } else {
        return list.filter(e => e !== '已付訂').filter(e => e !== '通知付訂')
      }
    },
    tableMoved (item) {
      if (item.store === this.area && this.moment(item.visitDate).isBetween(this.moment(this.range.start).startOf('day'), this.moment(this.range.end).endOf('day'), null, '[]')) {
        console.log('tablemoved', item)
        const index = this.rows.map(e => e._id).indexOf(item._id)
        if (index >= 0) {
          this.rows.splice(index, 1, item)
        }
      }
    },
    seatTook (item) {
      if (item.store === this.area && this.moment(item.visitDate).isBetween(this.moment(this.range.start).startOf('day'), this.moment(this.range.end).endOf('day'), null, '[]')) {
        console.log('seatTook IN IF', item)
        const sortlist = JSON.parse(JSON.stringify(this.rows.map(({ visitDate, visitTime, _id }) => { return { _id, dt: this.moment(`${this.toDate(visitDate)} ${visitTime}`) } }))).push({ _id: item._id, dt: this.moment(`${this.toDate(item.visitDate)} ${item.visitTime}`) })
        sortlist.sort((a, b) => a.dt.isBefore(b.dt))
        const index = sortlist.map(e => e._id).indexOf(item._id)
        console.table(sortlist)
        this.rows.splice(index, 0, item)
      }
    },
    onListen (bool) {
      if (bool) {
        global.socket.on('tablemoved', this.tableMoved)
        global.socket.on('seatTook', this.seatTook)
        global.socket.on('newOrder', this.seatTook)
        global.socket.on('OnlineNewOrder', this.seatTook)
        global.socket.on('orderUpdate', this.tableMoved)
        global.socket.on('cancelOrder', this.tableMoved)
      } else {
        global.socket.off('tablemoved', this.tableMoved)
        global.socket.off('seatTook', this.seatTook)
        global.socket.off('newOrder', this.seatTook)
        global.socket.off('OnlineNewOrder', this.seatTook)
        global.socket.off('orderUpdate', this.tableMoved)
        global.socket.off('cancelOrder', this.tableMoved)
      }
    },
    getnewteam ({ visitDate }) {
      this.$router.push({ name: 'visit', query: { date: visitDate } })
    },
    getExData (e) {
      const ratio = e.source && this.source.find(s => s.key === e.source)
      return {
        來源: e.createBy?.role === 'user' ? '使用者' : '後台新增',
        [e.createBy?.role === 'user' ? '使用者' : '後台新增']: e.createBy?.name,
        業務經辦: (e.salesman && e.salesman.name) || '-',
        業務來源: e.source || '-',
        分配比例: (ratio && ratio.value) || 0,
        狀態: e.status,
        用餐日期: this.toDate(e.visitDate),
        用餐時間: e.visitTime,
        預約人: e.orderer,
        預約電話: e.ordererTel,
        預約單位: e.agencyName,
        統一編號: e.agencyID,
        預約人數: (parseInt(e.reserveNum) || 0) + (parseInt(e.reserveNumChild) || 0),
        大人: e.reserveNum,
        小孩: e.reserveNumChild,
        桌數: this.reduce(e.Orders.filter(a => a.unit === '桌').map(a => a.count)),
        套數: this.reduce(e.Orders.filter(a => a.unit === '套').map(a => a.count)),
        總金額: this.reduce(e.Orders.map(a => a.count * this.priceEach(a))),
        餐點: e.Orders.map(a => {
          const r = [`${a.name} | ${a.price} x ${a.count}`]
          if (a.t === 'single') {
            const adds = [].concat(...a.items.map(e => e.add))
            console.log(a.name, this.priceEach(a), adds)
            for (const ad of adds) {
              r.push(`--${ad.item.name} | ${ad.price} x ${a.count}`)
            }
          } else {
            for (const b of a.items) {
              r.push(`-${b.name} | ${b.priceDiff} x ${a.count}`)
              for (const ad of b.add) {
                r.push(`--${ad.item.name} | ${ad.price} x ${a.count}`)
              }
            }
          }
          return r.join('\n')
        }).join('\n'),
        備註: e.remark || '-'
      }
    },
    exportFile () {
      const data = JSON.parse(JSON.stringify(this.rows))
      const json = data.filter(e => e.status !== '已取消').map(e => this.getExData(e))
      const worksheet = XLSX.utils.json_to_sheet(json)
      const json1 = data.filter(e => e.status === '已取消').map(e => this.getExData(e))
      const worksheet1 = XLSX.utils.json_to_sheet(json1)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, '預約表單')
      XLSX.utils.book_append_sheet(workbook, worksheet1, '取消')
      const name = this.range.duration ? `${this.range.start}_${this.range.end}_餐廳預約` : `${this.range.start}_餐廳預約`
      XLSX.writeFile(workbook, `${name}.xlsx`)
    },
    printSheet (item) {
      this.itemPrint = item
      this.$nextTick(() => {
        setTimeout(() => { this.print('printSheet') }, 800)
      })
    },
    print (page) {
      setTimeout(() => {
        let css = stringifyCss[page]
        if (/松柏軒/.test(this.area)) {
          css = css.replaceAll('{size}', '30')
        } else {
          css = css.replaceAll('{size}', '19')
        }
        const selector = '#preview.' + page
        const content = document.querySelector(selector)
        const ht = document.createElement('html')
        const head = document.createElement('head')
        const body = document.createElement('body')
        const title = document.createElement('title')
        title.innerText = `${this.area} ${page === 'instore' ? '內用列表' : page === 'takeout' ? '外帶列表' : page === 'tickets' ? '預約列表' : page === 'printSheet' ? '預約餐點' : page === 'sheet' ? '銷貨憑單' : '品項統計'}`
        const div = document.createElement('div')
        div.style.marginInline = 'auto'
        div.id = 'preview'
        div.innerHTML = content.innerHTML
        body.appendChild(div)
        head.appendChild(title)
        const style = document.createElement('style')
        style.media = 'print'
        style.appendChild(document.createTextNode(css))
        const style1 = document.createElement('style')
        style1.media = 'screen'
        style1.appendChild(document.createTextNode(css + 'body{margin:auto;width:210mm;background: #999999;}'))
        head.appendChild(style)
        head.appendChild(style1)
        ht.appendChild(head)
        ht.appendChild(body)
        const printWin = window.open('', '', '')
        printWin.document.write(`<html>${ht.innerHTML}</html>`)
        printWin.document.close()
        setTimeout(() => {
          printWin.print()
          this.printshow = false
        }, 500)
        return false
      }, 300)
    },
    async changeStatus (status, id, index, item) {
      if (status === '快速預約園區') {
        this.addTeam = JSON.parse(JSON.stringify(item))
      } else {
        const r = await this.$store.dispatch('save', {
          url: `webapi/restaurant/${id}`,
          body: { status }
        })
        this.rows[index].status = r.status
      }
    },
    async getproducts () {
      const products = await getapi(`rest_product/category/${this.area}?pos=true`)
      this.products = products
    },
    addItem (ev) {
      this.range = {
        start: this.toDate(ev.visitDate),
        end: this.toDate(ev.visitDate),
        duration: 0
      }
      this.addnew = null
    },
    remitUpdate (ev) {
      const index = this.rows.map(e => e._id).indexOf(ev._id)
      this.rows[index].remitInfo = ev.remitInfo
      this.rows[index].status = ev.status
      this.itemSelected = JSON.parse(JSON.stringify(this.rows[index]))
    },
    updateItem (ev) {
      const index = this.rows.map(e => e._id).indexOf(ev._id)
      this.rows.splice(index, 1, ev)
      this.itemSelected = ev
    },
    async getdata () {
      if (this.area) {
        const params = {
          date: this.moment(this.range.start).toISOString(),
          duration: this.range.duration,
          store: this.area
        }
        if (this.status) {
          params.status = this.status
        }
        if (this.searchText) {
          params.search = this.searchText
        }
        if (this.type) {
          params.type = this.type
        }
        if (this.sort && this.storeType === 'shop') {
          params.sort = this.sort
          params.asc = 1
        }
        const bookings = await getapi('restaurant?' + new URLSearchParams(params))
        this.rows = [...bookings.data.filter(e => e.status !== '已完成' && e.status !== '已取消'), ...bookings.data.filter(e => e.status === '已完成' || e.status === '已取消')]
        this.count = bookings.count
      }
    },
    async preview () {
      let params = `dateStart=${this.moment(this.range.start).startOf('day').toISOString()}&dateEnd=${this.moment(this.range.end).endOf('day').toISOString()}`
      if (this.storeType === 'shop' && this.sort === 'productionDate') {
        params = params + '&by=productionDate'
      }
      const summary = await getapi(`restaurant/summary/v1/${this.area}?${params}`)
      this.summary = summary
      setTimeout(() => {
        this.print('summary')
      }, 1000)
    }
  }
}
</script>
<style lang="scss">
.restView {
  #setDate-wrapper > .field > input[type=text] {
    border: 1px solid #CACACA;
  }
}
#preview {
  position: fixed;
  top: 100vh;
  // top: 0;
  right: 0;
  width: 210mm;
  height: 297mm;
  background-color: #FFFFFF;
  z-index: 100;
  overflow-y: auto;
  // padding: 10mm;
}
#printPreview {
  position: fixed;
  top: 90px;
  right: 0;
  width: 210mm;
  height: 297mm;
  background-color: #FFFFFF;
  z-index: 100;
}
</style>
<style lang="scss" scoped>
.messagecontainer {
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  &>:not(:last-child) {
    border: 1px solid #CACACA;
  }
  font-size: 20px;
  .phone {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 1em;
    width: 100%;
    &>div{
      white-space: nowrap;
      padding-left: 20px;
    }
  }
  textarea, input[type=tel] {
    width: 100%;
    padding: .5em 1em;
  }
}
.printBtn {
  width: 48px;
  height: 48px;
  border: none;
  border-radius: 5px;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  letter-spacing: .1em;
  color: #fff;
  background-color: var(--color-checked);
  box-shadow: 0 0 6px rgba(0,0,0,.25);
  box-sizing: border-box;
  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 10px 0;
}
div.vip, div.vvip, div.supervip, div.remarked, div.remark {
  width: 30px;
  height: 30px;
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: contain;
  appearance: none;
}
.flex {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;
}
div.tags {
  background-image: url(/tags.svg);
  background-size: 20px 25px;
}
div.remark {
  background-image: url(/remark.svg);
  background-size: 25px;
}
div.remarked {
  background-image: url(/remarked.svg);
  background-size: 25px;
}
div.vip {
  background-image: url(/vip.svg);
  mask-image: none;
}
div.supervip {
  background-image: url(/supervip.svg);
  mask-image: none;
}
div.vvip {
  background-image: url(/vvip.svg);
  mask-image: none;
}
.highlight {
  font-weight: 700;
  color: #FF8B8B;
}
.ordertype {
  margin: auto;
  padding-inline: 8px;
  min-width: 39px;
  width: fit-content;
  height: 39px;
  background: #7FA7DA;
  border-radius: 20px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  letter-spacing: 0.1em;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  &.宅配 {
    background-color: var(--宅配);
  }
  &.現場 {
    background-color: var(--現場);
  }
  &.自取 {
    background-color: var(--自取);
  }
  &.餐券 {
    background-color: var(--餐券);
  }
  &.男 {
    background-color: var(--男);
  }
  &.女 {
    background-color: var(--女);
  }
  &.戶外證婚 {
    background-color: var(--戶外證婚);
  }
  &.婚紗攝影 {
    background-color: var(--婚紗攝影);
  }
  &.內用 {
    background-color: #FFFFFF;
    border: 1.5px solid var(--內用);
    color: var(--內用);
    &.notable {
      background-color: var(--內用);
      color: #FFFFFF;
    }
    position: relative;
    &:hover::before {
      content: attr(aa);
      display: inline;
      width: fit-content;
      padding: 3px .25em;
      position: absolute;
      left: 0%;
      top: 45px;
      box-shadow: 3px 4px 15px rgba(0, 0, 0, 0.25);
      background-color: #00000080;
      color: #FFFFFF;
    }
  }
  &.外帶 {
    background-color: var(--外帶);
  }
}
</style>
